import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from '@zillow/constellation';

import { StyledHeader } from './StyledComponents';

const propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
};

const AlertWithTitle = ({
    title,
    body,
    ...rest
}) => {
    const renderBody = () => (
        <>
            <StyledHeader>{title}</StyledHeader>
            <div>{body}</div>
        </>
    );

    return (
        <Alert
            {...rest}
            body={renderBody()}
        />
    );
};

AlertWithTitle.propTypes = propTypes;

export default AlertWithTitle;
